import { render, staticRenderFns } from "./submitResult.vue?vue&type=template&id=369ce6e4&scoped=true&"
import script from "./submitResult.vue?vue&type=script&lang=js&"
export * from "./submitResult.vue?vue&type=script&lang=js&"
import style0 from "./submitResult.vue?vue&type=style&index=0&id=369ce6e4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "369ce6e4",
  null
  
)

export default component.exports